import { apiClient, type Paginated } from '@/core/api';
import type { TaxProfile, TaxProfileInput } from './types';

const BASE = '/hrm/tax-profiles/';

export interface TaxProfileListParams {
  page?: number;
  employee?: number;
}

export async function listTaxProfiles(
  params: TaxProfileListParams = {},
): Promise<Paginated<TaxProfile>> {
  const { data } = await apiClient.get<Paginated<TaxProfile>>(BASE, { params });
  return data;
}

export async function createTaxProfile(input: TaxProfileInput): Promise<TaxProfile> {
  const { data } = await apiClient.post<TaxProfile>(BASE, input);
  return data;
}

export async function updateTaxProfile(
  id: number,
  input: Partial<TaxProfileInput>,
): Promise<TaxProfile> {
  const { data } = await apiClient.patch<TaxProfile>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteTaxProfile(id: number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}
